import MessageThreadHeader from './MessageThreadHeader';

export default MessageThreadHeader;
